export const GET_RESOURCE_LIST = 'GET_RESOURCE_LIST';
export const CURRENT_PAGE = 'CURRENT_PAGE';
export const HAS_MORE = 'HAS_MORE';
export const RESET_RESOURCE_STATE = 'RESET_RESOURCE_STATE';

// 建设中心资源类型
export enum ResourceCategory {
  课堂实录 = 1,
  课件 = 2,
  素材 = 3,
  教案 = 4,
  普通作业 = 5,
  普通试卷 = 6,
  示范课 = 7,
  备课实录 = 8,
  微课 = 9,
  课时附件 = 10,
  结构化课件 = 11,
  直播 = 66,
}
